import React from 'react'
import { FormattedMessage } from 'react-intl';

const hasError = (field, errors, id) => {
  if (id === undefined) {
    return errors.find(error => error === field)
  } else {
    const personaError = errors.find(error => error.id === id);
    if (personaError) {
      return personaError.errors.find(error => error === field);
    }
  }
}

const RadioField = ({ field, label, value, persona, errors, onChange, options, ...rest }) => {
  const getErrorClass = () => hasError(field, errors, persona) ? 'field--error' : '';
  return (
    <div {...rest}>
      <div className={`field ${getErrorClass()}`}>
        <div className="field__label"><FormattedMessage id={label} defaultMessage={label} /></div>
        <form className="horizontal">
          {options.map(option => (
            <label htmlFor={`radio-${field}-${option.value}`} className="field__label field__radio" key={option.value}>
              <div className="field__textwrapper">
                <input id={`radio-${field}-${option.value}`} type="radio" name={field} value={option.value}
                  checked={value === option.value} onChange={onChange} />
                <span className="checkmark"></span>
              </div>
              <FormattedMessage id={option.label} defaultMessage={option.label} />
            </label>
          ))}
        </form>
      </div>
    </div>
  )
};

export default RadioField;